import exifr from 'exifr'
import type { ProofMetadata } from '@/types/file'

const EMPTY: ProofMetadata = { gps: null, takenAt: null, camera: null }

/**
 * Extract GPS + capture metadata from a proof photo's EXIF (client-side, best
 * effort). Videos and metadata-stripped images return empty. Never throws.
 */
export async function extractProofMetadata(file: File): Promise<ProofMetadata> {
  if (!file.type.startsWith('image/')) {
    return EMPTY
  }
  try {
    const data = await exifr.parse(file, { gps: true })
    if (!data) {
      return EMPTY
    }
    const gps =
      typeof data.latitude === 'number' && typeof data.longitude === 'number'
        ? { lat: data.latitude, lng: data.longitude }
        : null
    const taken = data.DateTimeOriginal ?? data.CreateDate
    const takenAt =
      taken instanceof Date ? taken.toISOString() : typeof taken === 'string' ? taken : null
    const camera = [data.Make, data.Model].filter(Boolean).join(' ').trim() || null
    return { gps, takenAt, camera }
  } catch {
    return EMPTY
  }
}
